import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './index.scss';
import '../../styles/menu.scss';
import '../../styles/container.scss';

const codeMenus = [
  { label: '算法', path: 'algorithm' },
  { label: '解决方案', path: 'solution' },
];

export default function Code() {
  const navigate = useNavigate();
  const location = useLocation();
  const activePath = location.pathname.split('/')[2] || codeMenus[0].path;
  const activeMenu = codeMenus.find(m => m.path === activePath) || codeMenus[0];

  return (
    <div className="page_container">
      {/* 左侧菜单栏 */}
      <div className="menu_sidebar">
        {codeMenus.map(menu => (
          <div
            key={menu.path}
            onClick={() => navigate(`/code/${menu.path}`)}
            className={`menu_item ${activePath === menu.path ? 'menu_item_active' : ''}`}
          >
            {menu.label}
          </div>
        ))}
      </div>
      {/* 右侧内容区 */}
      <div className="page_content_area">
        <h2 className="page_active_title">{activeMenu.label}</h2>
        <div className="page_content_placeholder">这里是「{activeMenu.label}」的内容区域。</div>
      </div>
    </div>
  );
} 